import { ReloadOutlined } from '@ant-design/icons'
import { Alert } from 'antd'
import { createStyles } from 'antd-style'

import { ThrottleButton } from '../Button/ThrottleButton'

import { DataErrorProps } from './interface'

const useStyles = createStyles((_, { block }: { block?: boolean }) => ({
  dataError: {
    display: block ? 'flex' : 'inline-flex',
    maxWidth: '100%',
    whiteSpace: 'pre-line',
    wordBreak: 'break-all'
  }
}))

/**
 * 数据请求异常时的提示，常用与表单组件
 */
export const DataError = ({
  className,
  style,
  block,
  error,
  loading,
  reload
}: DataErrorProps) => {
  const errMsg = error
    ? typeof error === 'string'
      ? error
      : error.message || (error as any)?.error
    : undefined

  const { cx, styles } = useStyles({ block })

  return error ? (
    <Alert
      showIcon
      className={cx(styles.dataError, className, 'test')}
      closable={false}
      description={errMsg}
      style={style}
      title='数据加载失败'
      type='warning'
      action={
        <ThrottleButton
          loading={loading}
          size='small'
          title='刷新'
          type='text'
          onClick={reload}
        >
          <ReloadOutlined />
        </ThrottleButton>
      }
    />
  ) : null
}
